import { TrashButton } from "@/components/tools/TrashButton";
import { PaperClipIcon } from "@heroicons/react/24/outline";

type RecordAttachmentRowProps = {
  name: string;
  size: number;
  deleteLabel: string;
  formatFileSize: (size: number) => string;
  onDelete: () => void;
};

export function RecordAttachmentRow({
  name,
  size,
  deleteLabel,
  formatFileSize,
  onDelete,
}: RecordAttachmentRowProps) {
  return (
    <div className="flex items-center gap-2 rounded-lg border border-softiq-primary/10 px-3 py-2 text-xs dark:border-white/10">
      <PaperClipIcon aria-hidden="true" className="size-4 shrink-0" />
      <span className="min-w-0 flex-1 truncate">{name}</span>
      <span className="app-section-meta shrink-0">{formatFileSize(size)}</span>
      <TrashButton
        label={`${deleteLabel} ${name}`}
        className="size-7"
        iconClassName="size-3.5"
        onClick={onDelete}
      />
    </div>
  );
}
